webpackJsonp([38],{

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_process_vue__ = __webpack_require__(818);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725564db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_process_vue__ = __webpack_require__(989);
function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-725564db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_process_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725564db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		buttonColor: buttonColor,
		isEditAction: isEditAction,
		isListAll: isListAll
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'green'
		},
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01775c3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("673c19a2", content, true, {});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-icon-button[data-v-01775c3c]{background:#f2f6f9!important;border:1px solid transparent;border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px}.action-icon-button .icon[data-v-01775c3c]{font-size:17px}.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef!important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa!important;border-color:#bed8ea}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-tooltip-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,6BAA8B,6BAA+B,kBAAkB,YAAY,eAAe,2FAA2F,mFAAmF,2EAA2E,uGAAuG,UAAU,CACxf,AACD,2CAA2C,cAAc,CACxD,AACD,2CAA2C,6BAA8B,qBAAqB,mCAAmC,0BAA0B,CAC1J,AACD,0DAA0D,6BAA8B,oBAAoB,CAC3G","file":"app-tooltip-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-icon-button[data-v-01775c3c]{background:#f2f6f9 !important;border:1px solid rgba(0,0,0,0);border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px\n}\n.action-icon-button .icon[data-v-01775c3c]{font-size:17px\n}\n.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef !important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa !important;border-color:#bed8ea\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"action-icon-button ma-0",class:{ 'is-edit-action': _vm.isEditAction },attrs:{"slot":"activator","flat":"","icon":"","aria-label":_vm.text,"small":"","color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[_c('v-icon',{style:(_vm.isListAll)},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(560);



var loadProcess = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							page: this.params.page,
							perPage: this.params.perPage,
							templateCode: this.$route.params.codeTemplate,
							projectCode: this.$route.params.codeProject
						};
						_context.next = 3;
						return this.$http.get('process', { params: params });

					case 3:
						response = _context.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadProcess() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadProcess();
}

function openProcess(_ref2) {
	var id = _ref2.id;

	this.goTo('page-configuration-process-integration-category', { params: { idProcess: id } });
}

function closeModal() {
	this.openAction = false;
}

function openAssign() {
	this.goTo('page-configuration-process-assign');
}

function changePage(page) {
	this.currentPage = page;
	this.loadProcess();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadProcess();
}

function returnListTemplate() {
	this.goTo('page-template');
}

function data() {
	return {
		openAction: false,
		columns: [{ id: 1, name: 'Código', value: 'code', checked: true, visible: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 3, name: 'Alcance', value: 'scope', checked: true, visible: true }, { id: 4, name: 'Modulo', value: 'module', checked: true, visible: true }, { id: 5, name: 'Estado', value: 'value', checked: true, visible: true }, { id: 6, name: 'Acciones', value: 'name', checked: true, visible: true }],
		currentPage: 0,
		lastPage: 0,
		title: 'Configurar Procesos',
		selectedValue: 'flagSelected',
		rows: [],
		params: {
			perPage: 10,
			page: 1,
			search: ''
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-configuration-process',
	data: data,
	created: created,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	methods: {
		changePage: changePage,
		closeModal: closeModal,
		loadProcess: loadProcess,
		openAssign: openAssign,
		openProcess: openProcess,
		onSearch: onSearch,
		returnListTemplate: returnListTemplate
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-configuration-process') {
					this.loadProcess();
				}
			}
		}
	}
});

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(988);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("0dd2e364", content, true, {});

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.w-btn[data-v-725564db]{width:125px!important}.color-green[data-v-725564db]{color:#4dc68c!important}.bold[data-v-725564db]{font-family:Lato_regular;font-weight:700}.color-red[data-v-725564db]{color:#f52c18!important}", "", {"version":3,"sources":["/opt/build/repo/src/pages/process/configuration-process.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,wBAAwB,qBAAsB,CAC7C,AACD,8BAA8B,uBAAwB,CACrD,AACD,uBAAuB,yBAA2B,eAAgB,CACjE,AACD,4BAA4B,uBAAwB,CACnD","file":"configuration-process.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.w-btn[data-v-725564db]{width:125px !important\n}\n.color-green[data-v-725564db]{color:#4dc68c !important\n}\n.bold[data-v-725564db]{font-family:\"Lato_regular\";font-weight:bold\n}\n.color-red[data-v-725564db]{color:#f52c18 !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showParentView('page-configuration-process'))?_c('div',[_c('section',[_c('header-page',{attrs:{"name":"configuration","title":_vm.$route.meta.title}}),_vm._v(" "),_c('div',{staticClass:"px-5 pb-5 mb-5"},[_c('app-table',{staticClass:"mt-5",attrs:{"columns":_vm.columns,"rows":_vm.rows,"last-page":_vm.lastPage,"current-page":_vm.currentPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v(_vm._s(props.row.code))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v(_vm._s(props.row.scope))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v(_vm._s(props.row.moduleName))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}]},[_c('span',{class:props.row.flagSelected === true ? 'color-green bold' : 'color-red bold'},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(props.row.flagSelected ? 'Activo' : 'Inactivo')+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}]},[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"build","text":"Asignar Categorías"},on:{"click-icon":function($event){return _vm.openProcess(props.row)}}})],1)]}}],null,false,887503554)})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('section',{staticClass:"modal-filter-footer"},[_c('v-layout',{attrs:{"xs12":"","justify-center":"","pt-4":"","pb-4":""}},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"pink"},nativeOn:{"click":function($event){return _vm.returnListTemplate.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{staticClass:"btn-action w-btn caption ml-1 pl-2 pr-2",attrs:{"color":"primary"},on:{"click":_vm.openAssign}},[_vm._v("\n\t\t\t\t\tAsignar Integración\n\t\t\t\t")])],1)],1)]),_vm._v(" "),_c('router-view')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/38.bbdcd015d7bbf7b54b4f.js